import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 16.25">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M8.12 16.25a8.13 8.13 0 118.13-8.12 8.14 8.14 0 01-8.13 8.12zm0-13.54a5.42 5.42 0 105.42 5.42 5.42 5.42 0 00-5.42-5.42zM32.5 16.25a8.13 8.13 0 118.12-8.12 8.13 8.13 0 01-8.12 8.12zm0-13.54a5.42 5.42 0 105.42 5.42 5.42 5.42 0 00-5.42-5.42zM56.88 16.25A8.13 8.13 0 1165 8.13a8.14 8.14 0 01-8.12 8.12zm0-13.54a5.42 5.42 0 105.41 5.42 5.42 5.42 0 00-5.41-5.42z"></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
